export const FROM_EXCEPTIONS = ['/two-factor', '/login', '/register']

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { getLocaleCookie, locale, setLocale } = useNuxtApp().$i18n
  const { isLoggedIn } = useAuth()
  const { mutate } = useChangePlayerLocaleMutation()
  const flutter = useFlutter()
  const { getSafeLocale, normalizeLocale } = useLocaleUtils()
  const { oldLocale } = useLanguageUtils()

  let playerLocale = getLocaleCookie()

  const newLocale = getSafeLocale(locale.value)

  if (FROM_EXCEPTIONS.some((route) => from.path.includes(route))) {
    return
  }

  if (isLoggedIn.value) {
    const data = await useUserDataLazyQuery({
      fetchPolicy: 'cache-first',
    }).load()

    if (!data) return

    playerLocale = normalizeLocale(data.player.locale)

    if (newLocale !== playerLocale) {
      oldLocale.value = normalizeLocale(data.player.locale)

      await mutate(
        {
          input: {
            locale: newLocale,
          },
        },
        {
          refetchQueries: [UserDataDocument],
        },
      )
    }
  }

  if (!playerLocale || !newLocale || newLocale === playerLocale) return

  await setLocale(newLocale)

  if (flutter) {
    flutter.updateAppLanguage(newLocale)
  }
})
